<template lang="pug">

    div

        //- Bewertungsformular
        .ui.segment

            h3.ui.header
                i.star.icon
                .content Bewertung erfassen

            .ui.form

                //- Bewertungsskala 1-5
                .field
                    label Bewertung (1–5)
                    .ui.massive.star.rating(ref="rating")

                //- Belege vorhanden
                .field
                    .ui.checkbox
                        input(
                            id="documentsComplete"
                            type="checkbox"
                            v-model="model.documentsComplete"
                        )
                        label(for="documentsComplete") Alle Belege vorhanden

                //- Betreff
                .field
                    label Betreff
                    input(
                        type="text"
                        placeholder="Betreff eingeben..."
                        v-model="model.subject"
                    )

                //- Notizen
                .field
                    label Notizen
                    textarea(
                        rows="5"
                        placeholder="Notizen eingeben..."
                        v-model="model.notes"
                    )

                //- Speichern
                .field
                    button.ui.primary.button(
                        type="button"
                        v-bind:class="{ loading: saving }"
                        v-bind:disabled="saving"
                        v-on:click="save"
                    ) Speichern

                //- Erfolgsmeldung
                .ui.success.message(v-if="saveSuccess")
                    | Bewertung wurde erfolgreich gespeichert.

                //- Fehlermeldung
                .ui.error.message(v-if="saveError")
                    | Beim Speichern ist ein Fehler aufgetreten.

</template>

<script>
    import store from '@/store'

    // noinspection JSUnusedGlobalSymbols,JSUnusedLocalSymbols
    export default {

        async beforeRouteEnter(to, from, next) {
            const productId = Number(to.params.id)
            const variantId = Number(to.params.variantId)

            await Promise.all([
                store.dispatch('products/loadOne', { id: productId }),
                store.dispatch('variants/loadOne', { id: variantId }),
                store.dispatch('ratings/loadAllByVariantId', { variantId }).catch(() => {}),
            ])

            next()
        },

        data() {
            return {
                model: {
                    overallScore: null,
                    documentsComplete: false,
                    subject: '',
                    notes: '',
                },
                saving: false,
                saveSuccess: false,
                saveError: false,
            }
        },

        computed: {

            variantId() {
                return Number(this.$route.params.variantId)
            },

            productId() {
                return Number(this.$route.params.id)
            },

            productModel() {
                return store.getters['products/byId'](this.productId)
            },

            variantModel() {
                return store.getters['variants/byId'](this.variantId)
            },

            existingRating() {
                const ratings = store.getters['ratings/allByVariantId'](this.variantId)
                return ratings.length > 0 ? ratings[0] : null
            },

        },

        methods: {

            loadModel() {
                const rating = this.existingRating
                if (rating) {
                    this.model = {
                        overallScore: rating.overallScore || null,
                        documentsComplete: rating.documentsComplete || false,
                        subject: rating.subject || '',
                        notes: rating.notes || '',
                    }
                } else {
                    this.model = {
                        overallScore: null,
                        documentsComplete: false,
                        subject: '',
                        notes: '',
                    }
                }
            },

            async save() {
                this.saving = true
                this.saveSuccess = false
                this.saveError = false

                try {
                    const rating = this.existingRating

                    if (rating) {
                        // Bestehende Bewertung aktualisieren
                        await store.dispatch('ratings/update', {
                            model: {
                                ...rating,
                                overallScore: this.model.overallScore,
                                documentsComplete: this.model.documentsComplete,
                                subject: this.model.subject,
                                notes: this.model.notes,
                            }
                        })
                    } else {
                        // Neue Bewertung erstellen
                        await store.dispatch('ratings/create', {
                            model: {
                                targetCompany: this.productModel ? this.productModel.company : null,
                                variant: this.variantId,
                                overallScore: this.model.overallScore,
                                documentsComplete: this.model.documentsComplete,
                                subject: this.model.subject,
                                notes: this.model.notes,
                                values: [],
                            }
                        })
                    }

                    this.saveSuccess = true
                } catch (e) {
                    this.saveError = true
                } finally {
                    this.saving = false
                }
            },

        },

        mounted() {
            this.loadModel()
            this.$nextTick(() => {
                $(this.$refs.rating).rating({
                    maxRating: 5,
                    initialRating: this.model.overallScore || 0,
                    onRate: (value) => {
                        this.model.overallScore = value
                    },
                })
            })
        },

        watch: {

            '$route.params.variantId'(variantId) {
                store.dispatch('ratings/loadAllByVariantId', { variantId }).catch(() => {}).then(() => {
                    this.loadModel()
                })
            },

            existingRating(rating) {
                if (rating) {
                    this.loadModel()
                }
            },

            'model.overallScore'(value) {
                this.$nextTick(() => {
                    $(this.$refs.rating).rating('set rating', value || 0)
                })
            },

        },

    }

</script>
